import { render, staticRenderFns } from "./PlantStationDetail.vue?vue&type=template&id=4a712f2c"
import script from "./PlantStationDetail.vue?vue&type=script&lang=js"
export * from "./PlantStationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports